import { useContext } from 'react';
import { ColorThemeContext, IColorThemeContext } from './ColorThemeContext';

export function useColorTheme(): IColorThemeContext {
  return useContext(ColorThemeContext);
}
